export default __webpack_public_path__ + "static/accessories-size-guide-b5f57fa949a738d3a9d91afc4daabdfa.jpg";